import { createAction } from 'redux-actions';

export const clearFields = createAction('CLEAR_FIELDS');



// WEBPACK FOOTER //
// ./src/redux/form/actions.js